import { ToastContainer } from 'react-toastify';
import { styled } from 'styled-components';
import { NavigationBar } from './NavigationBar';

const toastAutoClose = 10 * 1000;

export function Navigation() {
    return (
        <>
            <StyledToastContainer
                autoClose={toastAutoClose}
                closeOnClick={false}
                pauseOnHover={false}
                theme="colored"
            />
            <NavigationBar />
        </>
    );
}

const StyledToastContainer = styled(ToastContainer)`
    --toastify-icon-color-info: #fff;
    --toastify-icon-color-success: #fff;
    --toastify-icon-color-danger: #fff;
    --toastify-icon-color-warning: #fff;

    &&& {
        z-index: 9999;
        top: 68px;
        right: 16px;
        left: auto;
        width: 320px;

        .Toastify__toast {
            cursor: default;
            max-height: 800px;
            border-radius: 4px;
            margin-bottom: 16px;
            padding: 8px;
            font-family: 'Atlas Grotesk', Arial, sans-serif;
            font-size: 14px;
            line-height: 20px;
            font-weight: 500;
            word-break: break-word;
            -ms-word-break: break-all;
            color: #fff;

            &::first-letter {
                text-transform: uppercase;
            }

            .Toastify__toast-icon {
                margin-right: 12px;
                height: 20px;
                width: 20px;
            }

            .Toastify__close-button {
                color: #fff;
                opacity: 1;

                &:focus:not(:focus-visible) {
                    outline: none;
                    box-shadow: none;
                }
            }

            &.alert-info {
                background: #00adf8;
            }

            &.alert-success {
                background: #00d06a;
            }

            &.alert-danger {
                background: #af0f26;
            }

            &.alert-warning {
                background: #ff9a1e;
            }
        }
    }
`;
